(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/numbergames/pay.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  DIALOG_ACCOUNT_LOW_CANCEL
} = svs.tur.payment.constants.events;
const {
  isProductFamily,
  isSameProduct,
  isLotto,
  getProductName,
  getProductNumeric,
  getProductDrawId
} = svs.numbergames.productMapping;
class PayNumbergame extends svs.tur.payment.api.jupiter.base.PayBase {
  constructor(_ref) {
    let {
      wagerModel,
      alwaysPayable,
      draw = svs.numbergames.game.draw
    } = _ref;
    super({
      wagerModel
    });
    this.wagerModel = wagerModel;
    this.productName = wagerModel.get('productId');
    this.price = wagerModel.get('price');
    this.isProlonged = wagerModel.get('isProlonged');
    this.payableObj = wagerModel.toAPIJSON();
    this.syndicateId = wagerModel.get('syndicateId');
    this.alwaysPayable = alwaysPayable;
    this.draw = draw;
    this.onCancel = () => this.trigger(DIALOG_ACCOUNT_LOW_CANCEL);
    if (wagerModel.has('selectedDays') && wagerModel.get('selectedDays').length) {
      wagerModel.get('selectedDays').forEach(day => this.fetchUrls.push("/draw/1/".concat(getProductDrawId(day), "/draws")));
    } else {
      this.fetchUrls.push("/draw/1/".concat(getProductDrawId(wagerModel.get('productId')), "/draws"));
    }
  }
  initialize() {
    const wagerArray = Array.isArray(this.payableObj) ? this.payableObj : [this.payableObj];
    if (wagerArray.some(betsObj => betsObj.bets.some(bet => bet.drawNum === null))) {
      svs.tur.apierrors.showErrorMessage({
        response: 8105
      });
      return;
    }
    super.initialize();
  }
  onAccountStatusSuccess() {
    if (this.wasDrawOpenedToday()) {
      this.showPlayingNextDrawDialog({
        onConfirm: () => {
          super.onAccountStatusSuccess();
        }
      });
    } else if (this.isDrawClosedButPayable()) {
      this.fetchNextDraw({
        drawProduct: getProductDrawId(this.productName),
        drawNumber: this.draw.nextDrawNumber,
        onSuccess: draw => {
          const DrawClass = svs.numbergames.draws["".concat(getProductName(this.productName), "Draw")];
          this.draw = new DrawClass(draw);
          this.showPlayingNextDrawDialog({
            onConfirm: () => {
              super.onAccountStatusSuccess();
            }
          });
        },
        onError: () => {
          super.onAccountStatusSuccess();
        }
      });
    } else {
      super.onAccountStatusSuccess();
    }
  }
  wasDrawOpenedToday() {
    const openedItsId = this.draw.wasOpenedToday;
    if (openedItsId && isProductFamily(this.productName)) {
      return this.wagerModel.get('selectedDays').some(day => isSameProduct(day, openedItsId));
    }
    return Boolean(openedItsId);
  }
  isDrawClosedButPayable() {
    return !this.draw.drawNumber && this.draw.nextDrawNumber && this.alwaysPayable;
  }

  fetchNextDraw(_ref2) {
    let {
      drawProduct,
      drawNumber,
      onSuccess,
      onError
    } = _ref2;
    const path = "/draw/1/".concat(drawProduct, "/draws/").concat(drawNumber);
    svs.core.jupiter.call({
      method: 'GET',
      path
    }, _ref3 => {
      let {
        draw
      } = _ref3;
      onSuccess(draw);
    }, error => {
      svs.tur.payment.logger.warn("Request to ".concat(path, " responded with error!"), error);
      onError(error);
    });
  }
  isSyndicate() {
    return this.wagerModel.get('isSyndicate');
  }
  getSyndicate() {
    var _svs$syndicate, _svs$syndicate$accoun, _svs$syndicate$accoun2;
    const syndicateId = this.wagerModel.get('syndicateId');
    if ((_svs$syndicate = svs.syndicate) !== null && _svs$syndicate !== void 0 && (_svs$syndicate$accoun = _svs$syndicate.account_selector) !== null && _svs$syndicate$accoun !== void 0 && (_svs$syndicate$accoun2 = _svs$syndicate$accoun.data) !== null && _svs$syndicate$accoun2 !== void 0 && _svs$syndicate$accoun2.syndicates) {
      return svs.syndicate.account_selector.data.syndicates.find(s => s.syndicateId === syndicateId);
    }
    return false;
  }
  promptNextDraw(_ref4) {
    let {
      nextDrawDate,
      upcomingDrawProduct
    } = _ref4;
    this.payableObj = this.wagerModel.toAPIJSON();
    new svs.tur.payment.api.jupiter.numbergames.dialogs.PaymentConfirmNextDraw(_objectSpread({
      nextDrawDate,
      upcomingDrawProduct,
      onConfirm: () => {
        this.onPayConfirm();
      },
      onCancel: () => {
        this.onPayCancel();
      }
    }, this.getConfirmDialogProps()));
  }
  showPlayingNextDrawDialog(_ref5) {
    let {
      onConfirm
    } = _ref5;
    const currentDraw = isProductFamily(this.productName) ? this.draw[this.draw.wasOpenedToday] : this.draw;
    new svs.tur.payment.dialogs.PlayingNextDraw({
      productNumeric: getProductNumeric(this.productName),
      regCloseTime: currentDraw.closeTime,
      onCancel: () => {
        this.destroy();
      },
      onConfirm
    });
  }
  showSuccessDialog() {
    const hasJoker = this.wagerModel.get('hasJoker');
    const isSyndicate = this.wagerModel.get('isSyndicate');
    let andraChansen, afterDromVinsten;
    if (isLotto(this.productName) && hasJoker) {
      const wager = {
        drawCount: this.wagerModel.get('drawCount'),
        hasJoker,
        hasLotto2: this.wagerModel.get('rowPriceMulti') === 2,
        isFraction: false,
        isSyndicate,
        rowCount: this.wagerModel.get('numberOfValidBoards')
      };
      [andraChansen, afterDromVinsten] = svs.numbergames.andra_chansen.utils.chancesPerDrawType(this.drawData, wager);
    }
    new svs.tur.payment.api.jupiter.numbergames.dialogs.PaymentSuccess({
      andraChansen,
      afterDromVinsten,
      isSyndicate,
      onConfirm: () => {
        new svs.tur.CorrectionEmail({
          productName: getProductName(this.wagerModel.get('productId')),
          wagerCost: this.wagerModel.get('price'),
          callback: () => {
            this.onSuccessDialogConfirm();
          }
        }).show();
      }
    });
  }
}
svs.tur.payment.api.jupiter.numbergames.Pay = PayNumbergame;

 })(window);